// Welcome to Candela

// Third party imports
import axios from 'axios'
import {router} from './router'
import Vue from 'vue'
import VueGridLayout from 'vue-grid-layout'
import vuetify from './plugins/vuetify'

// Candela App
import App from '@/App'
import store from '@/store'

// Candela Components

// controls
import ControlPanel from '@/components/controls/ControlPanel'
import Button from '@/components/controls/Button'
import ButtonGroup from '@/components/controls/ButtonGroup'
import List from '@/components/controls/List'
import Progress from '@/components/controls/Progress'
import Select from '@/components/controls/Select'
import Slider from '@/components/controls/Slider'
import Toggle from '@/components/controls/Toggle'
import TextInput from '@/components/controls/TextInput'

// displays
import AnnotatedDoc from '@/components/displays/AnnotatedDoc'
import CellGrid from '@/components/displays/CellGrid'
import DataTable from '@/components/displays/DataTable'
import DonutChart from '@/components/displays/DonutChart'
import Markdown from '@/components/displays/Markdown'
import StatsBar from '@/components/displays/StatsBar'
import StatBox from '@/components/displays/StatBox'
import WordCloud from '@/components/displays/WordCloud'

// elements
import Icon from '@/components/elements/Icon.vue'

// plots
import AreaChart from '@/components/plots/AreaChart'
import AreaChartSpline from '@/components/plots/AreaChartSpline'
import AreaChartStepped from '@/components/plots/AreaChartStepped'
import Axis from '@/components/plots/Axis'
import BarChart from '@/components/plots/BarChart'
import GridLines from '@/components/plots/GridLines'
import GroupedBarChart from '@/components/plots/GroupedBarChart'
import GradientLegend from '@/components/plots/GradientLegend'
import HeatMap from '@/components/plots/Heatmap'
import Histogram from '@/components/plots/Histogram'
import Legend from '@/components/plots/Legend'
import LineChart from '@/components/plots/LineChart'
import LineChartStepped from '@/components/plots/LineChartStepped'
import LineChartSpline from '@/components/plots/LineChartSpline'
import Plot from '@/components/plots/Plot'
import ScatterPlot from '@/components/plots/ScatterPlot'
import StackedBarChart from '@/components/plots/StackedBarChart'
import {Orientations, ScaleTypes} from '@/components/plots/enums'

// settings
import ColorPicker from '@/components/settings/ColorPicker'
import ColorSpectrumPicker from '@/components/settings/ColorSpectrumPicker'
import DiscretePalettePicker from '@/components/settings/DiscretePalettePicker'
import ComponentSettings from '@/components/settings/Settings'
import SettingsControl from '@/components/settings/SettingsControl'
import ComponentSettingsDefaults from '@/components/settings/defaults'
import {SettingTypes} from '@/components/settings/creators'

// Candela Views
import AppPanel from '@/views/AppPanel'
import AppPanelItem from '@/views/AppPanelItem'
import ComponentList from '@/views/ComponentList'
import Console from '@/views/Console'
import SettingsPanel from '@/views/SettingsPanel'

// CSS
import 'firebaseui/dist/firebaseui.css'
import './styles/candela.sass'

// Config
Vue.config.productionTip = false
Vue.http = Vue.prototype.$http = axios
Vue.prototype.Orientations = Orientations
Vue.prototype.ScaleTypes = ScaleTypes
Vue.prototype.SettingTypes = SettingTypes
Vue.prototype.ComponentSettingsDefaults = ComponentSettingsDefaults

// Third party plugins
Vue.use(VueGridLayout)

// Register Candela Components
Vue.component('candela-annotated-doc', AnnotatedDoc)
Vue.component('candela-area-chart', AreaChart)
Vue.component('candela-area-chart-spline', AreaChartSpline)
Vue.component('candela-area-chart-stepped', AreaChartStepped)
Vue.component('candela-axis', Axis)
Vue.component('candela-bar-chart', BarChart)
Vue.component('candela-button', Button)
Vue.component('candela-button-group', ButtonGroup)
Vue.component('candela-cell-grid', CellGrid)
Vue.component('candela-color-picker', ColorPicker)
Vue.component('candela-color-spectrum-picker', ColorSpectrumPicker)
Vue.component('candela-component-settings', ComponentSettings)
Vue.component('candela-control-panel', ControlPanel)
Vue.component('candela-data-table', DataTable)
Vue.component('candela-discrete-palette-picker', DiscretePalettePicker)
Vue.component('candela-donut-chart', DonutChart)
Vue.component('candela-gradient-legend', GradientLegend)
Vue.component('candela-heatmap', HeatMap)
Vue.component('candela-histogram', Histogram)
Vue.component('candela-grid-lines', GridLines)
Vue.component('candela-grouped-bar-chart', GroupedBarChart)
Vue.component('candela-icon', Icon)
Vue.component('candela-legend', Legend)
Vue.component('candela-list', List)
Vue.component('candela-line-chart', LineChart)
Vue.component('candela-line-chart-spline', LineChartSpline)
Vue.component('candela-line-chart-stepped', LineChartStepped)
Vue.component('candela-markdown', Markdown)
Vue.component('candela-plot', Plot)
Vue.component('candela-progress', Progress)
Vue.component('candela-select', Select)
Vue.component('candela-scatter-plot', ScatterPlot)
Vue.component('candela-settings-control', SettingsControl)
Vue.component('candela-stacked-bar-chart', StackedBarChart)
Vue.component('candela-stats-bar', StatsBar)
Vue.component('candela-stat-box', StatBox)
Vue.component('candela-slider', Slider)
Vue.component('candela-toggle', Toggle)
Vue.component('candela-text-input', TextInput)
Vue.component('candela-word-cloud', WordCloud)

// Register Candela Views
Vue.component('candela-app-panel', AppPanel)
Vue.component('candela-app-panel-item', AppPanelItem)
Vue.component('candela-component-list', ComponentList)
Vue.component('candela-console', Console)
Vue.component('candela-settings-panel', SettingsPanel)

export const registered_component_names =
  new Set(Object.keys(Vue.options.components))

Vue.prototype.load_image = (path) => {
  return require(`@/assets/images/${path}`)
}

new Vue({
  components: {App},
  router,
  store,
  vuetify,
  template: '<App/>'
}).$mount('#app')
